export const SuccessMessages = {
  PRE_SIGNED_URL_SUCCESS: {
    DEFAULT: 'File successfully uploaded',
  },
  AVATAR: {
    UPDATED: 'Avatar successfully updated',
  },
};
